import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuthStore } from './stores/authStore'
import { ThemeProvider } from './contexts/ThemeContext'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import AdminPanel from './pages/AdminPanel'
import DeveloperPortal from './pages/DeveloperPortal'
import AppStore from './pages/AppStore'
import Profile from './pages/Profile'
import ApplyDeveloper from './pages/ApplyDeveloper'

function App() {
  const { isAuthenticated, user } = useAuthStore()

  const getDefaultRoute = () => {
    if (!isAuthenticated) return null
    if (user?.role === 'admin') return '/admin'
    if (user?.role === 'developer') return '/developer'
    return '/dashboard'
  }

  const defaultRoute = getDefaultRoute()

  const content = (
    <Routes>
      <Route path="/" element={!isAuthenticated ? <Home /> : <Navigate to={defaultRoute!} />} />
      <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to={defaultRoute!} />} />
      <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to={defaultRoute!} />} />
      
      <Route
        path="/dashboard"
        element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
      />
      <Route
        path="/dashboard/:dashboardId"
        element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
      />
      <Route
        path="/app-store"
        element={isAuthenticated ? <AppStore /> : <Navigate to="/login" />}
      />
      <Route
        path="/profile"
        element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}
      />
      <Route
        path="/apply-developer"
        element={isAuthenticated ? <ApplyDeveloper /> : <Navigate to="/login" />}
      />
      <Route
        path="/developer"
        element={
          isAuthenticated ? (
            <ProtectedRoute requiredRole="developer">
              <DeveloperPortal />
            </ProtectedRoute>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/admin"
        element={
          isAuthenticated ? (
            <ProtectedRoute requiredRole="admin">
              <AdminPanel />
            </ProtectedRoute>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
    </Routes>
  )

  return (
    <ThemeProvider>
      <Toaster position="top-right" />
      {content}
    </ThemeProvider>
  )
}

export default App

